<template>
  <component class="popup-text" :is="tag" :class="{ active }">
    <span
      v-for="(word, i) in words"
      :key="i"
      class="anim-text"
      :class="word.isSpace ? 'space' : 'word'"
    >
      <span v-if="!word.isSpace">
        <span
          v-for="(letter, j) in word.letters"
          :key="j"
          :style="{ animationDelay: `${letter.delay}s` }"
        >
          <span :style="{ animationDelay: `${letter.delay}s` }">{{
            letter.char
          }}</span>
        </span>
      </span>
      <span v-else>{{ ' ' }}</span>
    </span>
  </component>
</template>

<script>
@Component
class PopupText extends Vue {
  @Prop(String) text;
  @Prop({ type: Number, default: 0.1 }) delay;
  @Prop(String) tag;
  @Prop({ type: Boolean, default: true }) active;

  words = [];

  created() {
    let charCnt = 1;

    let words = this.text.split(' ');

    words.forEach((text, i) => {
      let word = {
        letters: [],
        isSpace: false
      };

      text.split('').forEach(char => {
        let delay = this.delay + charCnt++ * 0.05;
        word.letters.push({ char, delay });
      });

      this.words.push(word);

      if (i < words.length - 1) {
        this.words.push({ isSpace: true });
      }
    });
  }
}

export default PopupText;
</script>

<style lang="scss" scoped>
.popup-text {
  .anim-text {
  }

  .word {
    display: inline-block;
    white-space: nowrap;
    position: relative;

    > span {
      > span {
        > span {
          display: inline-block;
          transform: scale(0);

          > span {
          }
        }
      }
    }
  }

  .space {
  }

  &.active {
    .word {
      > span {
        > span {
          > span {
            animation-name: outterComponent;
            animation-duration: 0.5s;
            animation-fill-mode: both;
            animation-timing-function: cubic-bezier(0.26, 2.4, 0.58, 0.99);
          }
        }
      }
    }

    .space {
    }
  }
}

@keyframes outterComponent {
  0% {
    transform: scale(0);
  }

  100% {
    transform: scale(1);
    transform: translateX(1);
  }
}

@keyframes innerComponent {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PopupText.vue